/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const SignOutHeaders = zod.object({
  'x-csrf-token': zod.string(),
});

export type SignOutHeaders = zod.input<typeof SignOutHeaders>;
export type SignOutHeadersOutput = zod.output<typeof SignOutHeaders>;
